import { CompleteHistorySection } from "@/features/patient/clinical-history/components/CompleteHistoryView";
import { useClinicalHistory } from "@/features/patient/clinical-history/utils/adaptClinicalHistory";
import { usePatientProfile } from "@/portals/patient/context/PatientProfileContext";
import { useFamily } from "@/portals/patient/context/FamilyContext";

function ageFrom(dateOfBirth: string | null): number | null {
  if (!dateOfBirth) return null;
  const dob = new Date(dateOfBirth);
  if (Number.isNaN(dob.getTime())) return null;
  const diff = Date.now() - dob.getTime();
  return Math.abs(new Date(diff).getUTCFullYear() - 1970);
}

export function CompleteHistoryPage() {
  const { medicalHistory, familyHistory, isLoading } = useClinicalHistory();
  const { profile } = usePatientProfile();
  const { activeDependent } = useFamily();

  const name = activeDependent
    ? activeDependent.name
    : `${profile.firstName} ${profile.lastName}`.trim() || "You";
  const age = ageFrom(profile.dateOfBirth);
  const metaParts = [
    profile.gender ? profile.gender.charAt(0).toUpperCase() + profile.gender.slice(1) : null,
    age != null ? `Age ${age}` : null,
  ].filter(Boolean);

  const conditionCount = medicalHistory.filter((m) => m.type === "condition").length;

  return (
    <CompleteHistorySection
      medicalHistory={medicalHistory}
      familyHistory={familyHistory}
      isLoading={isLoading}
      self={{
        name,
        meta: metaParts.join(" · "),
        conditionCount,
      }}
    />
  );
}
